import { Appearance } from 'react-native';

export default Appearance;
